import { Issue } from '../FlowConfig/types'

export type YamlValidatorReducerState = {
  issues: Issue[]
  isIssuesDrawerOpen: boolean
  minimized: boolean
  oneIssueActive: boolean
  currentIssue: Issue | null
  filters: {
    [key in AllowedFilters]: {
      value: any | any[]
      allowedValues: any
    }
  }
}

export type AllowedFilters = 'categorizeBy' | 'object_type' | 'issueType'

export const AllowedObjectTypes = Object.freeze({
  Block: 'Block',
  Action: 'Action',
  FlowConfig: 'FlowConfig',
  Path: 'Path',
  PromptContent: 'PromptContent',
  Prompt: 'Prompt',
  SubFlow: 'SubFlow',
})

// export type Issue = {
//     message: string;
//     type: string;
//     object_type: string;
//     object_id: number;
//     subflow_id?: null;
//     field: string;
//     name: string;
// }
